import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import GA4Event from "@analytics/GoogleAnalytics/GA4Event";
import { logEvent } from "@analytics/GoogleAnalytics/GA4Service";
import * as Sentry from "@sentry/react";
import { logClientError } from "@service/ClientLoggingService";
import { UnknownGlobalClientErrorEvent } from "./AmplitudeSystemEvent";

const amplitudeService = AmplitudeService.getInstance();

const handleGlobalAppError = (error: Error, info: { componentStack: string }) => {
    logEvent(GA4Event.GLOBAL_ERROR_FALLBACK);
    Sentry.captureException(error);
    amplitudeService.logEvent(
        new UnknownGlobalClientErrorEvent({
            eventCode: error.name,
            eventMessage: error.message,
            eventStackString: error.stack,
        }),
    );
    logClientError(error);
};

export { handleGlobalAppError };
